<template>
    <div>
        <section-header
            ref="selectHeader"
            title="Select Independent Variable(s)"
        ></section-header>
        <div class="well">
            <analysis-variable-selection
                ref="analysisVariableSelection"
                variableType="independent"
                v-model="selectedVariable"
                :isEnabled="true"
                :theVariable="selectedVariable"
                :isRequired="true"
                v-on:variableIsSelected="(v) => (selectedVariable = v)"
            ></analysis-variable-selection>
        </div>
        <div class="buttons">
            <input
                type="button"
                value="Add"
                class="btn btn-secondary btn-block"
                v-on:click="addSelectedVariable"
                title="Add"
                :disabled="
                    !selectedVariable.variable ||
                    !selectedVariable.variable.variable
                "
            />
        </div>
        <h4>
            <label for="selectedVariables">Selected Variables</label>
        </h4>
        <single-select-list
            :bind="independentVariables"
            :startingSelectedValue="variableToRemove"
            :isEnabled="true"
            listId="selectedVariables"
            v-on:variableIsSelected="(v) => (variableToRemove = v)"
        ></single-select-list>

        <div class="buttons">
            <input
                type="button"
                value="Remove"
                class="btn btn-secondary btn-block"
                v-on:click="removeSelectedVariable"
                title="Remove"
                :disabled="!variableToRemove"
            />
            <input
                type="button"
                value="Remove All"
                class="btn btn-secondary btn-block"
                v-on:click="removeAllVariables"
                title="Remove All"
            />
            <!--disabled="selectionModel.v.independent.length === 0" />-->
        </div>
        <app-navigator
            ref="appNavigator"
            :router="$router"
            nextButtonTitle="Select one or more variables to continue"
        ></app-navigator>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off', no-useless-return: 'off' */
import current from '@/scripts/current';
import singleSelectList from '@/components/singleSelectList';
import variableSelectionHelper from '@/scripts/variableSelectionHelper';
import commonModelHelper from '@/scripts/commonModelHelper';
import store from '@/store';
import sectionHeader from '@/components/sub/sectionHeader';
import appNavigator from '@/components/layout/appNavigator';
import analysisVariableSelection from '@/components/analysisVariableSelection';

export default {
    components: {
        singleSelectList,
        sectionHeader,
        appNavigator,
        analysisVariableSelection
    },
    data() {
        var vm = this;
        current.initializeLogisticRegressionValues(vm);

        var omittedVariables = commonModelHelper.getSelectedVariables(
            current.selectionModel,
            ['dependent']
        );
        current.selectionModel.v.independent.forEach(
            (v, i) => (omittedVariables[v.variable.variable] = true)
        );
        commonModelHelper.initializeStep(vm, 'selectIndependentVariables');
        return {
            modelHelper: current.modelHelper,
            initialOmittedVariables: commonModelHelper.getSelectedVariables(
                current.selectionModel,
                ['dependent']
            ),
            omittedVariables,
            selectedVariable: {
                group: null,
                include: true,
                type: null,
                variable: null
            },
            variableToRemove: null,
            selectionModel: current.selectionModel,
            variableSelectionHelper,
            independentVariables: []
        };
    },
    mounted() {
        let vm = this;
        refreshLocalVariableList(vm);
        if (vm.$refs.analysisVariableSelection)
            vm.$refs.analysisVariableSelection.updateSelection({
                omittedVariables: vm.omittedVariables
            });
    },
    methods: {
        addSelectedVariable,
        removeSelectedVariable: function () {
            var vm = this;
            removeVariable(
                current.selectionModel.v.independent,
                vm.variableToRemove,
                (v) => v.variable.variable
            );
            refreshLocalVariableList(vm);
            vm.omittedVariables[vm.variableToRemove] = false;
            refreshAndMaintainSelectedGroup(vm);
            store.dispatch('selModel/setReadyForNextStep');
        },
        removeAllVariables: function () {
            var vm = this;
            //current.selectionModel.v.independent = [];
            //Remove all selected variables.If we replace this, then the selectVariable watcher doesn't work
            current.selectionModel.v.independent.splice(
                0,
                current.selectionModel.v.independent.length
            );
            refreshLocalVariableList(vm);
            //Reset the omitted variables.  If we replace the omitted variables, then the selectVariable watcher doesn't work
            Object.keys(vm.omittedVariables).forEach(function (k) {
                if (!vm.initialOmittedVariables[k])
                    vm.omittedVariables[k] = false;
            });
            refreshAndMaintainSelectedGroup(vm);
            store.dispatch('selModel/setReadyForNextStep');
        }
    }
};

function addSelectedVariable() {
    var vm = this;

    //Year and Type are just a variable
    if (this.selectedVariable.type === 'year')
        this.omittedVariables.year = true;
    else if (this.selectedVariable.type === 'location')
        this.omittedVariables.location = true;
    else this.omittedVariables[this.selectedVariable.variable.variable] = true;
    current.selectionModel.v.independent.push(vm.selectedVariable.copy());
    refreshLocalVariableList(vm);

    refreshAndMaintainSelectedGroup(vm);
    vm.selectedVariable.variable = null;
    store.dispatch('selModel/setReadyForNextStep');
}

function refreshLocalVariableList(vm) {
    vm.independentVariables = current.selectionModel.v.independent.map(
        (v) => v.variable
    );
}

function removeVariable(list, variableName, variableNameSelector) {
    list.forEach((v, i) => {
        // let itemName = isVariableSelectionList ? v.variable.variable : v.variable;
        if (variableNameSelector(v) === variableName) {
            list.splice(i, 1);
            return;
        }
    });
    // selectionModelIndependentVariables.forEach((v, i) => {
    //   if (v.variable.variable === variableName) {
    //     selectionModelIndependentVariables.splice(i, 1);
    //     return;
    //   };
    // });
    // current.selectionModel.v.independent.forEach(function (v, i) {
    //   if (v.variable.variable === variableName) {
    //     current.selectionModel.v.independent.splice(i, 1);
    //     vm.omittedVariables[vm.variableToRemove] = false;
    //     refreshAndMaintainSelectedGroup(vm);
    //     return;
    //   };
    // });
}

function refreshAndMaintainSelectedGroup(vm) {
    if (vm.$refs.analysisVariableSelection)
        vm.$refs.analysisVariableSelection.updateSelection({
            isRefresh: true,
            omittedVariables: vm.omittedVariables
        });
}
</script>

<style scoped>
.spaced-out {
    margin-top: 20px;
    margin-bottom: 20px;
}

.dropdown-menu label.radio input[type='radio'] {
    visibility: hidden;
}

.dropdown-menu label.radio {
    padding-left: 10px;
}

.buttons {
    float: left;
    width: 100%;
    margin-top: 10px;
}

input[type='button'] {
    width: 220px;
    float: left;
    padding: 5px 15px;
    margin: 0 10px 10px 10px;
    box-sizing: border-box;
}

@media only screen and (max-width: 540px) {
    input[type='button'] {
        width: 100%;
        margin: 0 0 10px 0;
    }
}

h4 {
    font-weight: 600;
}
</style>
